function chooseHeader(type) {
  switch (type) {
    case '0':
      return 'customAuteco';
    case '1':
      return 'success';
    case '2':
      return 'warning';
    case '3':
      return 'info';
    default:
      return 'customAuteco';
  }
}

export default chooseHeader;
